import type { ComponentProps } from 'react';
import { Br } from '@/ui';
import { Header } from '../../components/Header';
import { Heading } from '../../components/Heading';

type HeaderProps = ComponentProps<typeof Header>;

export const Hero = (props: HeaderProps) => {
  return (
    <Header {...props}>
      <Heading>
        Turn your Canva design into{' '}
        <Br display={{ base: 'none', sm: 'block' }} /> an interactive calendar
        with AI
      </Heading>
    </Header>
  );
};
